import {
  BillingPlan,
  BillingPlanBE,
  BillingPlanFeature,
  BillingPlanFeatureBE,
} from '@/types/billing-plan';

export const mapBillingPlanFeatureBEsToDTO = (
  billingPlanFeatureBE: BillingPlanFeatureBE
): BillingPlanFeature => {
  return {
    name: billingPlanFeatureBE.name,
    type: billingPlanFeatureBE.type,
    description: billingPlanFeatureBE.description,
    rates: billingPlanFeatureBE.rates,
  };
};

export const mapBillingPlanFeaturesBEsToDTO = (
  billingPlanFeatureBEArray: BillingPlanFeatureBE[]
): BillingPlanFeature[] => {
  return billingPlanFeatureBEArray.map((billingPlanFeatureBE) => {
    return mapBillingPlanFeatureBEsToDTO(billingPlanFeatureBE);
  });
};

export const mapBillingPlanBEsToDTO = (
  billingPlanBE: BillingPlanBE
): BillingPlan => {
  return {
    id: billingPlanBE.id.toString(),
    name: billingPlanBE.name,
    description: billingPlanBE.description,
    price: Number(billingPlanBE.price),
    currency: billingPlanBE.currency,
    features: mapBillingPlanFeaturesBEsToDTO(billingPlanBE.features),
  };
};

export const mapBillingPlansBEsToDTO = (
  billingPlanBEArray: BillingPlanBE[]
): BillingPlan[] => {
  return billingPlanBEArray.map((billingPlanBE) => {
    return mapBillingPlanBEsToDTO(billingPlanBE);
  });
};

export const mapBillingPlanDTOToBEForCreate = (
  billingPlan: Partial<BillingPlan>
): Partial<BillingPlanBE> => {
  return {
    name: billingPlan.name,
    description: billingPlan.description,
    features: billingPlan.features,
    price: billingPlan.price,
  };
};

export const mapBillingPlanDTOToBEForUpdate = (
  billingPlan: Partial<BillingPlan>
): Partial<BillingPlanBE> => {
  return {
    id: Number(billingPlan.id),
    name: billingPlan.name ?? undefined,
    description: billingPlan.description ?? undefined,
    features: billingPlan.features ?? undefined,
    price: billingPlan.price,
  };
};
